<template>
  <el-dialog
    title="选择车型"
    width="1000px"
    :close-on-click-modal="false"
    :visible.sync="visible"
    append-to-body
    custom-class="choose-auto-series"
    @close="clear">
    <div v-loading="loading">
      <div class="choose-cartype-container">
        <div class="tabs">
          <div class="tab-item" @click="changeTab(0)" :class="{'tab-active': tabIdx == 0}">选择车型</div>
          <div class="tab-item" @click="changeTab(1)" :class="{'tab-active': tabIdx == 1}">车系搜索</div>
        </div>
        <!-- 选择车型 -->
        <div v-show="tabIdx === 0">
          <el-steps :active="active" simple>
            <el-step title="选择品牌"></el-step>
            <el-step title="选择车系"></el-step>
            <el-step title="选择排量"></el-step>
            <el-step title="选择年款"></el-step>
            <el-step title="选择销售型"></el-step>
          </el-steps>
          
          <div class="choose-list" v-show="chooseData.length > 0">
            <span>已选品牌：</span>
            <span :key="index" v-for="(item,index) in chooseData" class="choose-item" v-show="index < 5">
              {{ item }}<i class="el-icon-close" @click="clearSelected(index)"></i>
            </span>
          </div>

          <!-- 选择品牌 -->
          <div v-show="active == 0 ">
            <div class="type-sort">
              <div :class="['sort-item', {active: currentTarget === -1}]" @click="changeType(-1)">热门品牌</div>
              <div :class="['sort-item', {active: currentTarget === key}]"
                v-for="(value, key) in brandOptions" :key="key"
                @click="changeType(key)">{{ key }}
              </div>
            </div>
            <div class="type-list">
              <template v-if="nowCarType && nowCarType[0]">
                <div class="type-item" v-for="(item, index) in nowCarType" :key="index" @click="choosePP(item)">
                  <img class="type-logo" :src="QN_URL_BASE + item.Logo" :onerror="defaultImg" />
                  <span>{{item.Cn}}</span>
                  <!-- <div class="choose-panel">
                    <div @click="returnPP(item)">选择品牌</div> | <div @click.stop="choosePP(item)">细分车系</div>
                  </div> -->
                </div>
              </template>
              <template v-else>
                <div class="no-data">暂无数据</div>
              </template>
            </div>
          </div>

          <!-- 选择车系 -->
          <div v-show="active === 1">
            <div v-for="(ele, key) in carModelData" :key="key">
              <div class="type-name">{{ key }}</div>
              <div class="type-list">
                <div v-for="(i, idx) in ele" :key="idx" class="type-item" @click="chooseCx(i)">
                  {{i.AutoSerieName}}
                </div>
              </div>
            </div>
          </div>
          
          <!-- 选择排量 -->
          <div v-show="active === 2">
            <div class="type-list">
              <div class="type-item" v-for="(item, index) in plData" :key="index" @click="choosePL(item)">
                {{item.Emission}}
              </div>
            </div>
          </div>
          
          <!--  选择年款 -->
          <div v-show="active === 3">
            <div class="type-list">
              <div class="type-item" v-for="(item,index) in nfData" :key="index" @click="chooseNF(item)">
                {{item.ModelYear}}
              </div>
            </div>
          </div>
          
          <!--  选择销售型 -->
          <div v-show="active === 4">
            <div class="type-list">
              <div class="type-item" v-for="(item,index) in xsxData" :key="index" @click="chooseXSX(item)">
                {{item.SaleModel}}
              </div>
            </div>
          </div>
          
          <!--选择车型-->
          <div v-show="active === 5" class="choose-success">车型选择成功</div>

        </div>
        <!-- 车系搜索 -->
        <div v-show="tabIdx === 1 ">
          <div class="search-view">
            <el-input class="search-input" placeholder="请输入品牌或车系" v-model="searchKey"></el-input>
            <el-button class="btn-primary" slot="append" icon="el-icon-search" @click="searchType">搜索</el-button>
          </div>
          <div v-for="(item, idx) in searchResult" :key="idx">
            <div class="type-name">{{ item.ManufacturerName }}</div>
            <div class="type-list">
              <div class="type-item" v-for="(row, idx2) in item.DetailList" :key="idx2" @click="chooseSearchResult(row)">
                {{ row.AutoSerieName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      tabIdx: 0,
      loading: false,
      visible: false,
      searchKey: '', // 搜索字段
      searchResult: [], // 搜索结果
      active: 0, // 步骤进度
      currentTarget: -1,  // 当前active索引
      chooseData: [], // 选中的数据，固定格式：[品牌, 车系, 排量, 年款, SId]
      nowCarType: null, // 当前显示的车系,.默认热门车牌
      brandOptions: {}, // 品牌快搜字段集合
      hotOptions: [], // 热门品牌列表
      carModelData:{},  // 某品牌车的车系数据
      plData: [], // 排量
      nfData: [], // 年款
      xsxData: [], // 销售型
      brandId:"", //选中的品牌id

      defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE + '"',
      QN_URL_BASE: this.$util.QN_URL_BASE
    }
  },
  methods: {
    // 去除已选品牌
    clearSelected (idx) {
      this.active = idx
      this.chooseData.splice(idx)
    },
    // 选择销售型 - 选择后即成功
    chooseXSX (row) {
      this.chooseData.push(row.SaleModel)
      this.chooseData.push(row.SId)
      this.active = 5
      this.$emit('chooseResult', {
        Cn: this.chooseData[0],
        AutoSerieName: this.chooseData[1],
        Emission: this.chooseData[2],
        ProducedYear: this.chooseData[3],
        SaleModel: this.chooseData[4],
        SId: this.chooseData[5]
      })
    },
    // 选择年款
    chooseNF (row) {
      this.chooseData.push(row.ModelYear)
      this.loading = true
      this.$util.axiosGet({
        url: 'api/Auto/GetSaleModels',
        data: {
          sName: row.Cn,
          Emission: this.chooseData[2],
          ModalYear: row.ModelYear,
          bId:this.brandId
        }
      }).then(res => {
        this.xsxData = res.data
        this.active = 4
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 根据车系的名称及排量去获取车系年份数据
    choosePL (row) {
      this.chooseData.push(row.Emission)
      this.loading = true
      this.$util.axiosGet({
        url: 'api/Auto/GetYearByEmissionAndSName',
        data: {
          sName: row.Cn,
          Emission: row.Emission,
          bId:this.brandId
        }
      }).then(res => {
        this.nfData = res.data
        this.active = 3
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 根据车系的名称去获取排量数据
    chooseCx (row){
      this.chooseData.push(row.AutoSerieName)
      this.loading = true
      this.$util.axiosGet({
        url: 'api/Auto/GetEmissionByAutoSeriesName',
        data: {
          sName: row.AutoSerieName,
          bId:this.brandId
        }
      }).then(res => {
        this.plData = res.data
        this.active = 2
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    //根据品牌Id获取对应生产商的所有车系
    choosePP (row) {
      this.brandId=row.Id;
      this.chooseData.push(row.Cn)
      this.loading = true
      this.$util.axiosGet({
        url:'api/Auto/GetAutoSeriesByBId',
        data: {
          bId: row.Id
        }
      }).then(res => {
        this.active = 1
        this.carModelData = res.data
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 切换选择品牌索引
    changeType (index) {
      this.currentTarget = index
      if (index === -1) {
        this.nowCarType = this.hotOptions
        return
      }
      let arrList = Object.entries(this.brandOptions)
      if (!Array.isArray(arrList)) return
      let findIndex = arrList.findIndex(item => item[0] === index)
      if (~findIndex) this.nowCarType = this.brandOptions[arrList[findIndex][0]]
    },
    // 返回首字母排序好的车品牌
    getBrands () {
      this.loading = true
      this.$util.axiosGet({
        url: 'api/Auto/GetAllAutoBrands'
      }).then(res => {
        let data = res.data
        delete data.hot
        this.brandOptions = data
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 获取热门品牌
    getHotBrands () {
      this.loading = true
      this.$util.axiosGet({
        url: '/api/Auto/GetHotAutoBrands'
      }).then((res)=> {
        this.hotOptions = res.data
        this.nowCarType = res.data
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 根据车系的名称去获取排量数据
    chooseSearchResult (row) {
      this.brandId=row.BrandId;
      this.chooseData = [
        row.BrandName
      ]
      this.tabIdx = 0
      this.chooseCx(row)
    },
    // 搜索车系
    searchType () {
      this.loading = true
      this.$util.axiosGet({
        url:'/api/Auto/GetVehicleSeriesList',
        data: {
          Keyword: this.searchKey,
        }
      }).then((res)=> {
        this.searchResult = res.data
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 切换Tab
    changeTab (i) {
      this.tabIdx = i;
    },
    show () {
      this.getBrands()
      this.getHotBrands()
      this.visible = true
    },
    hide () {
      this.visible = false
    },
    clear () {
      Object.assign(this.$data, {
        tabIdx: 0,
        searchKey: '',
        searchResult: [],
        active: 0,
        currentTarget: -1,
        chooseData:[]
      })
    }
  }
}
</script>

<style>
.choose-auto-series .el-dialog__body {
  padding: 0;
}
</style>

<style lang="less" scoped>
.choose-cartype-container {
  padding: 20px;
  min-height: 400px;
  max-height: 600px;
  overflow-y: scroll;
}
.tabs{
  border-bottom: 1px solid @border1Color;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
  .tab-item {
    text-align: center;
    width: 120px;
    padding: 10px;
    border-bottom: none;
    cursor: pointer;
  }
}
.search-view {
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  .search-input {
    flex: 1;
    margin-right: 16px;
  }
}
.el-steps--simple {
  padding: 13px 2.5%;
  margin-bottom: 20px;
}

.choose-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 32px;
  margin-bottom: 20px;
  .choose-item {
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
    margin-right: 10px;
    border: 1px solid @theme;
    i {
      cursor: pointer;
    }
  }
}

.choose-panel {
  opacity: 0;
  position: absolute;
  top: 0;
  left:0 ;
  width: 100%;
  height: 100%;
  background: rgba(255,255,255,0.9);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  div:hover {
    color: @theme;
  }
}

.type-sort {
  padding-bottom: 20px;
  display: flex;
  .sort-item {
    padding: 5px 10px;
    font-weight: bold;
    cursor: pointer;
  }
  .active {
    background: @theme;
    color: #fff;
  }
}

.choose-success {
  font-size: @font-lg;
  margin-top: 70px;
  text-align: center;
}

// 选择栏样式
.type-name {
  background: @border4Color;
  padding: 10px 20px;
  border-left: 5px solid @theme ;
  margin-bottom: 10px;
}
.type-list {
  display: flex;
  flex-wrap: wrap;
  .type-item {
    position: relative;
    width: 162px;
    line-height: 22px;
    padding: 10px;
    border: 1px solid @border4Color;
    margin: 0 10px 10px 0;
    text-align: center;
    cursor: pointer;
    &:hover {
      border: 1px solid @theme;
      .choose-panel {
          opacity: 1;
      }
    }
  }
  .type-logo {
    width: 30px;
    height: 30px;
    margin-right: 20px;
  }
  .no-data {
    width: 100%;
    height: auto;
    margin-top: 60px;
    line-height: normal;
    text-align: center;
  }
}
</style>